var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavicon01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9991 20.9989V12.9989C14.9991 12.7337 14.8938 12.4793 14.7063 12.2918C14.5187 12.1043 14.2644 11.9989 13.9991 11.9989H9.99915C9.73393 11.9989 9.47958 12.1043 9.29204 12.2918C9.1045 12.4793 8.99915 12.7337 8.99915 12.9989V20.9989",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99976 9.99911C2.99969 9.70821 3.06308 9.42079 3.18553 9.15691C3.30797 8.89302 3.48651 8.65903 3.70869 8.47125L10.708 2.4728C11.069 2.16774 11.5263 2.00037 11.9989 2.00037C12.4715 2.00037 12.9289 2.16774 13.2898 2.4728L20.2892 8.47125C20.5114 8.65903 20.6899 8.89302 20.8123 9.15691C20.9348 9.42079 20.9982 9.70821 20.9981 9.99911V18.9983C20.9981 19.5287 20.7874 20.0373 20.4124 20.4124C20.0373 20.7874 19.5287 20.9981 18.9983 20.9981H4.99957C4.46919 20.9981 3.96053 20.7874 3.58549 20.4124C3.21045 20.0373 2.99976 19.5287 2.99976 18.9983V9.99911Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon01);
export default __webpack_public_path__ + "static/media/navicon01.707672773ebb43b9735eac8f7e0f848b.svg";
export { ForwardRef as ReactComponent };